var $6faa3defebc3eb72$exports = {};
$6faa3defebc3eb72$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Fargevelger`,
    "colorSwatch": `fargekart`,
    "transparent": `gjennomsiktig`,
    "twoDimensionalSlider": `2D-glidebryter`
};


export {$6faa3defebc3eb72$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
